import { StaticAssetPreview } from '@1stLog-engineering/file-uploads'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/sharp-solid-svg-icons'
import { Group, Text } from '@mantine/core'
import lodash, { concat, isEmpty } from 'lodash'
import React, { useMemo } from 'react'

import Card from '../../../../../1stlog-ui/src/components/Card'

const InvoiceDocuments = (props) => {
  const {
    invoiceDocument = [],
    additionalCustomsDocs = [],
    proformaInvoice,
  } = props

  const items = useMemo(() => {
    return concat(invoiceDocument, additionalCustomsDocs)
  }, [invoiceDocument, additionalCustomsDocs])

  if (lodash.isEmpty(items)) {
    return null
  }

  return (
    <Card title={i18n.t('invoice_documents', 'Rechnung und Zolldokumente')}>
      <div>
        {proformaInvoice ? (
          <Group>
            <FontAwesomeIcon icon={faCheck} fontSize="1.3rem" />
            <Text>
              {i18n.t(
                'proforma_invoice_no_create',
                'Proforma Rechnung wird erstellt',
              )}
            </Text>
          </Group>
        ) : (
          <Group>
            <FontAwesomeIcon icon={faTimes} fontSize="1.3rem" />
            <Text>
              {i18n.t(
                'proforma_invoice_no_create',
                'Proforma Rechnung wird nicht erstellt',
              )}
            </Text>
          </Group>
        )}
      </div>
      {!isEmpty(invoiceDocument) && (
        <>
          <h5>{i18n.t('trade_invoice_label', 'Handelsrechnung')}</h5>
          <StaticAssetPreview
            assets={invoiceDocument}
            maxWidth="100%"
            height="200px"
          />
        </>
      )}
      {!isEmpty(additionalCustomsDocs) && (
        <>
          <h5>
            {i18n.t('additional_customs_docs', 'Zusätzliche Zolldokumente')}
          </h5>
          <StaticAssetPreview
            assets={additionalCustomsDocs}
            maxWidth="100%"
            height="200px"
          />
        </>
      )}
    </Card>
  )
}

export default InvoiceDocuments
